<button (click)="goBack()" class="btn btn-round btn-primary btn-mini mb-3">< {{ 'BackToAllSites' | translate }}</button>

<div *ngIf="editMode" class="add-site-title">
  @switch (editMode) {
    @case ('create') {
      <span [innerHTML]="'NouveauSite' | translate"></span>
    }
    @case ('update') {
      <span [innerHTML]="'ConfigurationSite' | translate"></span>
      <ng-container *ngIf="site">
        <span>&nbsp;/&nbsp;</span>
        <app-host-mode-label class="mx-1" [siteMode]="site.mode" />
        <span
          class="text-primary"
        >{{ site.domainName }}</span
        >
        <a class="ogo-link" target="_blank" [href]="site.originScheme + '://' + site.domainName">
          <i class="icofont icofont-external-link ml-2"></i>
        </a>
        <app-site-status-full [site]="site" />
      </ng-container>
    }
  }
  <hr />
</div>
@if (editMode === 'create' || site) {
  <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs" [hidden]="editMode != 'update'">
    <li [ngbNavItem]="Tab.GENERAL" class="site-mode-BASIC" id="tab-{{ Tab.GENERAL }}">
      <button (click)="goToTab(Tab.GENERAL)" [class]="activeTab === Tab.GENERAL ? 'active' : ''" class="nav-link">
        {{ 'General' | translate }}
      </button>
      <ng-template ngbNavContent>
        <app-general-config
          *ngIf="editMode"
          [site]="editMode == 'update' ? site : {}"
          [editMode]="editMode"
          [hasPushLog]="auth.currentOrganization.hasPushLogConfig"
          [goBack]="goBack"
        />
      </ng-template>
    </li>

    <li [ngbNavItem]="Tab.CERTIFICATES" class="site-mode-BASIC" id="tab-{{ Tab.CERTIFICATES }}">
      <button
        (click)="goToTab(Tab.CERTIFICATES)"
        [class]="activeTab === Tab.CERTIFICATES ? 'active' : ''"
        class="nav-link"
      >
        {{ 'Certificates' | translate }} / TLS
        @if (isACertificateInError) {
          <app-certificate-error-label [placement]="'middle'" />
        }
      </button>
      <ng-template ngbNavContent>
        <app-certificates *ngIf="site" [site]="site" (isACertificateInError)="refreshSite()" />
      </ng-template>
    </li>

    <li [ngbNavItem]="Tab.EXCEPTIONS" class="site-mode-BASIC" id="tab-{{ Tab.EXCEPTIONS }}">
      <button (click)="goToTab(Tab.EXCEPTIONS)" [class]="activeTab === Tab.EXCEPTIONS ? 'active' : ''" class="nav-link">
        {{ 'Exceptions' | translate }}
      </button>
      <ng-template ngbNavContent>
        <app-exceptions *ngIf="site" [site]="site" />
      </ng-template>
    </li>

    <li [ngbNavItem]="Tab.GEO_BLOCKING" class="site-mode-ADVANCED" id="tab-{{ Tab.GEO_BLOCKING }}">
      <button
        (click)="goToTab(Tab.GEO_BLOCKING)"
        [class]="activeTab === Tab.GEO_BLOCKING ? 'active' : ''"
        class="nav-link"
      >
        {{ 'Geoblocking' | translate }}
      </button>
      <ng-template ngbNavContent>
        <app-geoblock *ngIf="site" [site]="site" />
      </ng-template>
    </li>

    <li [ngbNavItem]="Tab.RULES" class="site-mode-ADVANCED" id="tab-{{ Tab.RULES }}">
      <button (click)="goToTab(Tab.RULES)" [class]="activeTab === Tab.RULES ? 'active' : ''" class="nav-link">
        {{ 'AccessControl' | translate }}
      </button>
      <ng-template ngbNavContent>
        <app-rules *ngIf="site" [siteName]="site.domainName" [clusterConfig]="cluster" />
      </ng-template>
    </li>

    <li [ngbNavItem]="Tab.REWRITE_RULES" class="site-mode-ADVANCED" id="tab-{{ Tab.REWRITE_RULES }}">
      <button
        (click)="goToTab(Tab.REWRITE_RULES)"
        [class]="activeTab === Tab.REWRITE_RULES ? 'active' : ''"
        class="nav-link"
      >
        {{ 'Rewrite' | translate }}
      </button>
      <ng-template ngbNavContent>
        <app-rewrite-rules *ngIf="site" [site]="site" />
      </ng-template>
    </li>

    <li
      id="tab-{{ Tab.CACHE_CDN }}"
      *ngIf="cluster?.supportsCache"
      [ngbNavItem]="Tab.CACHE_CDN"
      class="site-mode-ADVANCED"
    >
      <button (click)="goToTab(Tab.CACHE_CDN)" [class]="activeTab === Tab.CACHE_CDN ? 'active' : ''" class="nav-link">
        {{ 'Site.Settings.Tab.' + (cdnEnabled ? Tab.CACHE_CDN : Tab.CACHE) | translate }}
      </button>
      <ng-template ngbNavContent>
        <app-cache-cdn *ngIf="site" [siteName]="site.domainName" [showCdn]="cdnEnabled" />
      </ng-template>
    </li>

    <li [ngbNavItem]="Tab.ADVANCED" class="site-mode-ADVANCED" id="tab-{{ Tab.ADVANCED }}">
      <button (click)="goToTab(Tab.ADVANCED)" [class]="activeTab === Tab.ADVANCED ? 'active' : ''" class="nav-link">
        {{ 'Advanced' | translate }}
      </button>
      <ng-template ngbNavContent>
        <app-brain-overrides
          *ngIf="site"
          [site]="site"
          [visibility]="'advanced'"
          [enableSearch]="false"
          [showWarning]="false"
          [brainParametersGroupsSource]="getBrainParametersGroups"
          [brainParametersSource]="getBrainParameters"
        />
      </ng-template>
    </li>

    <li [ngbNavItem]="Tab.EXPERT" class="site-mode-EXPERT" id="tab-{{ Tab.EXPERT }}">
      <button (click)="goToTab(Tab.EXPERT)" [class]="activeTab === Tab.EXPERT ? 'active' : ''" class="nav-link">
        {{ 'Expert' | translate }}
      </button>
      <ng-template ngbNavContent>
        <app-brain-overrides
          *ngIf="site"
          [site]="site"
          [visibility]="'expert'"
          [showVisibility]="true"
          [brainParametersGroupsSource]="getBrainParametersGroups"
          [brainParametersSource]="getBrainParameters"
        />
      </ng-template>
    </li>
  </ul>

  <div [ngbNavOutlet]="nav" class="container-fluid px-lg-4 pb-4 pt-3"></div>
}
